<template>
    <div class="sustainable-component wage-result-statistics">
        <!--
    <div class="bg-success mb-3 p-3 rounded">vue component wage-result-statistics</div>
    -->
        <div class="container-fluid p-0">
            <div class="container-fluid p-0">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <table class="table table-light table-hover table-striped">
                            <thead class="thead-light">
                                <tr>
                                    <th>Namn</th>
                                    <th>Datum</th>
                                    <th>Länk</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(resultRow, index) in savedDocuments" :key="index">
                                    <td>{{resultRow.Name}}</td>
                                    <td>{{resultRow.Date}}</td>
                                    <td><a v-bind:href="'/WageSettingsExcel/GetSavedAnalysis?name=' + resultRow.Name + '&filename=' + resultRow.Path">Ladda ner</a></td>
                                    <td class="col-2">
                                        <div class="pull-right" style="" v-if="disabled == false">
                                            <div class="dropdown text-right pr-2">
                                                <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                    ...
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-right">
                                                    <a href="javascript:void(0)" class="dropdown-item" @click="deleteSavedAnalysis(resultRow.Id)">Ta bort</a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-result-statistics',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async getSavedAnalysises() {
                this.loading++;
                try {
                    this.savedDocuments = await WageService.getSavedAnalysises();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async deleteSavedAnalysis(documentId) {
                if (confirm(" Är du säker att du vill radera analysen?")) {
                    this.loading++;
                    try {
                        await WageService.deleteSavedAnalysis(documentId);
                        this.displaySnackBar("Borttaget");
                        this.getSavedAnalysises();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                savedDocuments: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.getSavedAnalysises();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
